import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { Field, ErrorMessage } from "formik";
import { CurrentTheme, MagstimDropdown } from "common";
import MagstimInputGroup from './MagstimInputGroup'

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupClinicalRating extends MagstimInputGroup {

    onCheckboxChange = () => {
        const newCheckState = !this.state.checked;
        this.setState({ checked: newCheckState, disabled: !newCheckState })

        if (this.props.onSetEnabled !== undefined) {
            this.props.onSetEnabled(this.props.name, newCheckState, this.props.validateForm);
        }
    }

    render() {

        var titleClassName = "input-group-highlight"

        if(this.state.disabled === true){
            titleClassName = "input-group-disabled"
        }

        return (
            <Wrapper>

                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
                </InputGroupAddon>

                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
                    </InputGroupAddon>

                    <InputGroupAddon addonType="append" className="magstim-checkbox-container mr-3">
                        <Input type="checkbox" className="magstim-checkbox" checked={this.state.checked} onChange={this.onCheckboxChange} />
                    </InputGroupAddon>

                    <div className="input-div">
                        <Input type="number"
                            disabled={this.state.disabled}
                            autoComplete={AUTO_COMPLETE_OFF}
                            onFocus={this.onFocus}
                            name="ClinicalRatingMin"
                            placeholder="Min"
                            tag={Field}
                            className={`form-control ${this.props.touched.ClinicalRatingMin && this.props.errors.ClinicalRatingMin ? "is-invalid" : ""}`} />

                        <ErrorMessage component="div" name="ClinicalRatingMin" className="invalid-feedback" />
                    </div>

                    <div className="input-space" />

                    <div className="input-div">

                        <Input type="number"
                            disabled={this.state.disabled}
                            autoComplete={AUTO_COMPLETE_OFF}
                            onFocus={this.onFocus}
                            name="ClinicalRatingMax"
                            placeholder="Max"
                            tag={Field}
                            className={`form-control ${this.props.touched.ClinicalRatingMax && this.props.errors.ClinicalRatingMax ? "is-invalid" : ""}`} />

                        <ErrorMessage component="div" name="ClinicalRatingMax" className="invalid-feedback" />
                    </div>

                    <div className="input-space" />

                    <div className="input-div">
                        <MagstimDropdown size={CurrentTheme().ControlSize} ref={this.props.dropDownRef} disabled={this.state.disabled} onSelect={this.props.onSelect}>
                            {this.props.options.map(option => (
                                this.dropdownItem(option, this.props.default)
                            ))}
                        </MagstimDropdown>
                    </div>

             

                </InputGroup>
            </Wrapper>
        );
    }
}

MagstimInputGroupClinicalRating.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    touched: PropTypes.object,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onSetEnabled: PropTypes.func,
    options: PropTypes.array,
    default: PropTypes.string,
    dropDownRef: PropTypes.object,
    onSelect: PropTypes.func,
    validateForm: PropTypes.func
};

MagstimInputGroupClinicalRating.defaultProps = {
    title: "",
    name: "",
    touched: false,
    errors: undefined,
    disabled: false,
    checked: undefined,
    onSetEnabled: undefined,
    options: [],
    default: "",
    dropDownRef: undefined,
    onSelect: undefined,
    validateForm: undefined
};

const Wrapper = styled.div`

.input-space{
    width:10px;
}

.input-div{
    flex: 1 1 auto;
    width:100px; /* CB: Not sure why this works, but it stops in input boxes having a min size - min-size does not work */
}

@media only screen and (max-width: 520px) {
    .input-space {
      padding-bottom: 50px; /* add more padding when the controls wrap */
    }
  }

`

export default MagstimInputGroupClinicalRating